import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * Wrapper around useState to be used if state is set asynchronoly to prevent errors if the component is already unmounted
 */
function useSafeState(initialValue) {
    const [value, setter] = useState(initialValue)
    const mountState = useRef(true)

    useEffect(
        () => () => {
            mountState.current = false
        },
        []
    )

    // make setter stable, ie do not trigger rerender of pure components this is passed as a prop to
    const saveSetter = useCallback(newValue => mountState.current && setter(newValue), [])

    return [value, saveSetter]
}

export { useSafeState }
